<template>
  <div class="LibHeaderInput">
    <i class="iconfont icon-sousuo sosuoIconfont"></i>
    <el-input
      v-model="keyWorde"
      placeholder="请输入项目名称、编号、关键词，多关键词用空格隔开"
      maxlength="100"
      @keyup.enter.native="handleSearch"
    ></el-input>
    <el-button class="HeaderInputButton" type="primary" round @click="handleSearch"> 搜索</el-button>
  </div>
</template>

<script>
import { OLD_SEARCH_PAGE } from "../../utils/constants/constants";
import { getLoginStatus } from "../../utils/common";
export default {
  name: "LibHeaderInput",
  props: [],
  data() {
    return {
      keyWorde: "",
    };
  },
  computed: {
    isLogin() {
      return getLoginStatus();
    },
  },
  created() {},
  mounted() {},
  methods: {
    
    handleSearch() {
      const keywordParam = this.isLogin ? "keyword" : "keywords";
      
      window.open(`${OLD_SEARCH_PAGE()}?${keywordParam}=${encodeURIComponent(this.keyWorde)}`);
      if(this.isLogin){
         location.reload()
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/config";

.LibHeaderInput {
  max-width: 480px;
    flex: 1;
    background: #fff;
    border: 1px solid #df6250;
    border-radius: 20px;
    display: flex;
    align-items: center;
    padding-left: 18px;
    min-width: 120px;
    position: relative;
  .sosuoIconfont {
    color: #a2a6ac;
    font-size: 14px;
  }
  .el-input {
    ::v-deep .el-input__inner {
      border: 0;
      font-size: 14px;
      height: 34px;
      padding-left: 7px;
      padding-right: 28px;
      border-radius: 31px;
      background: #fff;
    }
  }

  .HeaderInputButton {
    position: absolute;
    height: 36px;
    top: -1px;
    right: -3px;
    border-radius: 0 30px 30px 0;
    padding-top: 10px;
    width: 79px;
    &:hover {
      background: #f66d59;
      border-color: #f66d59;
    }
  }
}
</style>
